document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll(".page-navigation-links a");
    const firstNavLink = navLinks[0]; // First link in navigation
    const pageNav = document.querySelector(".page-navigation"); // The navigation container
    let lastScrollY = window.scrollY; // Track last scroll position

    function removeActiveClass() {
        navLinks.forEach(link => link.classList.remove("__active"));
    }

    // Smooth scroll on click
    navLinks.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const targetId = this.getAttribute("href");
            const targetSection = document.querySelector(targetId);

            if (targetSection) {
                window.scrollTo({
                    top: targetSection.offsetTop - 100,
                    behavior: "smooth"
                });

                removeActiveClass();
                this.classList.add("__active");
            }
        });
    });

    // Detect scroll direction and activate first link when scrolling up
    window.addEventListener("scroll", function () {
        let scrollY = window.scrollY;
        let isScrollingUp = scrollY < lastScrollY; // Detect scroll direction
        lastScrollY = scrollY; // Update last scroll position

        const pageNavRect = pageNav.getBoundingClientRect();

        if (isScrollingUp && pageNavRect.top >= 0) {
            removeActiveClass(); // Remove all active classes
            firstNavLink.classList.add("__active"); // Add active class to the first link
        }
    });
});
